import isNil from 'lodash/isNil';
import moment from 'moment';
import { DateIcon } from 'tombac-icons';
import { LimitSummaryContainer, LimitSummaryIcon, LimitSummaryLimit } from "./limitSummaryElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DateLimitSummary({
  className,
  limit,
  schema
}) {
  return !isNil(limit) ? /*#__PURE__*/_jsxs(LimitSummaryContainer, {
    className: className,
    schema: schema,
    children: [/*#__PURE__*/_jsx(LimitSummaryIcon, {
      as: DateIcon
    }), ' ', /*#__PURE__*/_jsx(LimitSummaryLimit, {
      children: moment(limit).format('DD/MM/YYYY')
    })]
  }) : null;
}